<template>
  <v-container fluid class="white page__container--padding">
    <div class="d-flex align-items-center">
      <v-card
        class="mx-auto rounded-lg elevation-4 ma-3 w-100"
        outlined
        :style="'border: 4px solid black; background-color:transparent;'"
      >
        <v-list-item-content>
          <div class="text-general-module mb-0">
            <v-icon color="black"> mdi mdi-account-cash </v-icon>
            ESTADO DE CUENTA DEL {{ opt == 'byGroup' ? 'GRUPO' : 'CLIENTE' }}
          </div>
        </v-list-item-content>
      </v-card>
    </div>

    <!-- Menu -->
    <buttonsr-group-customer :opt="opt" />
    <!-- End Menu -->

    <!-- Datos del cliente con grupo o sin grupo -->
    <data-customer class="mt-5" :data-client="dataClient" :loader="loader" />

    <v-row>
      <v-col cols="12">
        <!-- Botonera -->
        <div v-if="opt !== 'byGroup'" class="buttons__container">
          <div class="buttons__colum buttons__colum-1 d-flex">
            <div class="flex-fill">
              <search-input
                v-model="search"
                :hide-details="true"
                :placeholder="'Buscar documento'"
                class="m-2"
              />
            </div>

            <div class="d-flex flex-wrap justify-center gap-2">
              <v-btn
                class="btn-multipago red-button"
                @click="isAccountStatementRecordOpen = true"
              >
                Histórico estado de cuenta
              </v-btn>

              <v-btn class="btn-multipago blue-button" @click="buildPdfReport">
                Descargar Estado de Cuenta
              </v-btn>
            </div>
          </div>

          <div class="buttons__colum buttons__colum-2">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  class="btn-multipago button-green"
                  v-bind="attrs"
                  v-on="on"
                  @click="isOpenPayment = true"
                >
                  Anticipo c/ factura
                </v-btn>
              </template>
              <span>
                Si usted paga en esta opción, se generará factura por el
                anticipo. <br />
                En este apartado no se hacen pagos de facturas de materiales, ni
                pagos parciales, solo pagos por Anticipo.
              </span>
            </v-tooltip>
            <router-link :to="{ name: 'AccountStatus' }">
              <v-btn class="btn-multipago red-button"> Realizar pagos </v-btn>
            </router-link>
          </div>

          <div class="buttons__colum buttons__colum-3">
            <div class="text-left mr-5">
              <p class="mb-0">
                <b
                  >Bono Rebate (s/IVA): ${{
                    bonusRebate.MONTO | formatCurrency
                  }}</b
                >
              </p>
              <p class="mb-0">
                <b
                  >Saldo disponible: ${{
                    bonusRebate.DISPO | formatCurrency
                  }}</b
                >
              </p>
            </div>
            <router-link
              :to="
                disableMultipaymentRebate
                  ? ''
                  : { name: 'AccountStatus', params: { disc: 'BR' } }
              "
            >
              <v-btn
                class="btn-multipago red-button"
                :disabled="disableMultipaymentRebate"
              >
                Aplicar bono Rebate
              </v-btn>
            </router-link>
          </div>

          <div class="buttons__colum buttons__colum-3">
            <div class="text-left mr-5">
              <p class="mb-0">
                <b>Bono POP (s/IVA): ${{ bonus.MONTO | formatCurrency }}</b>
              </p>
              <p class="mb-0">
                <b>Saldo disponible: ${{ bonus.DISPO | formatCurrency }}</b>
              </p>
            </div>
            <router-link
              :to="
                disableMultipayment
                  ? ''
                  : { name: 'AccountStatus', params: { disc: 'PSPO' } }
              "
            >
              <v-btn
                class="btn-multipago red-button"
                :disabled="disableMultipayment"
              >
                Aplicar bono POP
              </v-btn>
            </router-link>
          </div>
        </div>
        <!-- Fin Botonera -->

        <title-header-table>
          <span>Movimientos al {{ dateCurrent }}</span>
        </title-header-table>

        <v-data-table
          id="mi-tabla-reporte"
          :headers="dataClient?.CTEGPO > 0 ? headers : headers.slice(2, 13)"
          :items="filteredItems"
          :search="search"
          class="elevation-2 table__desing-general"
          :loading="loading"
          loading-text="Cargando... Por favor espere"
          :items-per-page="-1"
          hide-default-footer
        >
          <template #[`header.TIPO`]="{ header }">
            {{ header.text }}
            <v-select
              v-model="selectedTIPO"
              :items="documentsAll"
              label="Todos los Documentos"
              item-text="option"
              item-value="value"
              dense
              solo
              hide-details
            />
          </template>

          <template #[`header.KUNNR`]="{ header }">
            {{ header.text }}
            <v-select
              v-model="selectedKUNNR"
              :items="customersAll"
              label="Todos los Clientes"
              item-text="option"
              item-value="value"
              dense
              solo
              hide-details
            />
          </template>

          <template #[`header.STCD1`]="{ header }">
            {{ header.text }}
            <v-select
              v-model="selectedSTCD1"
              :items="rfcAll"
              label="Todos los RFC"
              item-text="option"
              item-value="value"
              dense
              solo
              hide-details
            />
          </template>

          <template #foot>
            <tfoot>
              <tr>
                <td
                  :colspan="dataClient?.CTEGPO > 0 ? 11 : 9"
                  class="text-right foot-sub-total"
                >
                  <b>Subtotales:</b>
                </td>
                <td class="foot-sub-total">
                  <b>${{ sumToExpire | formatCurrency }}</b>
                </td>
                <td class="foot-sub-total">
                  <b style="color: red">${{ sumExpired | formatCurrency }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="13" class="text-right foot-total">
                  <b>Saldo total: ${{ sumAmount | formatCurrency }}</b>
                </td>
              </tr>
            </tfoot>
          </template>

          <template #item="{ item }">
            <row-table-movements
              :invoice="item"
              :is-group="parseInt(dataClient.CTEGPO)"
              @actionButton="validateInsertOrDelete(item)"
            />
          </template>

          <template #no-data>
            <alert-prominent
              v-if="messageAlert"
              :message="messageAlert"
              class="ma-3"
            />
          </template>
        </v-data-table>

        <title-header-table class="mt-5">
          <span>Información de notas de crédito/Cargo</span>
        </title-header-table>

        <v-simple-table class="elevation-2 table__desing-general">
          <template #default>
            <thead>
              <tr>
                <th width="30%">Concepto</th>
                <th width="70%">Descripción del concepto</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="concepts.length > 0">
                <tr v-for="(concept, index) in concepts" :key="index">
                  <td>{{ concept.code }}</td>
                  <td>{{ concept.description }}</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="2">
                    <i>Sin conceptos</i>
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>

        <v-row class="mt-4">
          <v-col cols="12" md="6">
            <p class="mb-0 py-3">
              Para efectos de la fórmula de PPDP, la fecha de pago que se
              registra en nuestro sistema es aquella en la que la factura queda
              saldada y compensada en su totalidad
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <dialog-glosary />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <confidentiality-notice />

    <!-- Payment Card -->
    <v-dialog v-model="isOpenPayment" width="500" persistent>
      <bank-payment-card
        :user-channel="user.VTWEG"
        :customer-code="customerCode"
        :invoice="0"
        :type-pay="2"
        @close="isOpenPayment = false"
      />
    </v-dialog>
    <!-- End Payment Card -->

    <account-status-card
      v-model="isAccountStatementRecordOpen"
      :customer-code="customerCode"
      :customer-group="customerGroup"
    />
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex';
  import { jsPDF } from 'jspdf';
  import DialogGlosary from './components/DialogGlosary';
  import ButtonsrGroupCustomer from '@/components/ButtonsrGroupCustomer';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice';
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import DataCustomer from '@/components/DataCustomer.vue';
  import RowTableMovements from './components/RowTableMovements';
  import TitleHeaderTable from '@/components/tables/TitleHeaderTable';
  import SearchInput from '@/components/SearchInput.vue';
  import BankPaymentCard from '@/components/BankPaymentCard.vue';
  import userAuthOrStorage from '@/mixins/userAuthOrStorage';
  import AccountStatusCard from '@/components/AccountStatusCard.vue';
  import AlertProminent from '@/components/AlertProminent.vue';
  import helpers from '@/mixins/helpers';
  import reportPdfMixin from '@/mixins/reportPdfMixin';

  export default {
    name: 'AccountStatement',
    components: {
      DialogGlosary,
      ConfidentialityNotice,
      ButtonsrGroupCustomer,
      DataCustomer,
      RowTableMovements,
      TitleHeaderTable,
      SearchInput,
      BankPaymentCard,
      AccountStatusCard,
      AlertProminent,
    },
    mixins: [userAuthOrStorage, reportPdfMixin, helpers],
    props: {
      opt: {
        type: String,
        default: 'byCustomer',
      },
    },
    data() {
      return {
        loader: true,
        dateCurrent: moment().format('D [de] MMMM [del] YYYY HH:mm:ss a'),
        search: '',
        headers: [
          {
            text: 'N° de Cliente',
            value: 'KUNNR',
            align: 'center',
            sortable: false,
          },
          { text: 'RFC', value: 'STCD1', align: 'center', sortable: false },
          {
            text: '# documento',
            value: 'BELNR',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Orden de Compra',
            value: 'ORDCOM',
            align: 'center',
            sortable: false,
          },
          { text: 'Descargas', value: 'ver', align: 'center', sortable: false },
          {
            text: 'Tipo de documento',
            value: 'TIPO',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de Documento',
            value: 'BUDAT',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de Entrega',
            value: 'FACUS',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Fecha de Vencimiento',
            value: 'FVENC',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Días vencido',
            value: 'DVENC',
            align: 'center',
            sortable: false,
          },
          { text: 'Importe', value: 'DMBTR', align: 'center', sortable: false },
          {
            text: 'Saldo sin vencer',
            value: 'por_vencer',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Saldo Vencido',
            value: 'vencido',
            align: 'center',
            sortable: false,
          },
        ],
        items: [],
        dataClient: {},
        selectedKUNNR: '',
        selectedSTCD1: '',
        selectedTIPO: '',
        itemCSV: [],
        bonus: {
          MONTO: 0,
          DISPO: 0,
        },
        bonusRebate: {
          MONTO: 0,
          DISPO: 0,
        },
        disableMultipayment: true,
        customerCode: null,
        isOpenPayment: false,
        sortBy: [],
        sortDesc: [],
        messageAlert: '',
        loading: false,
        isAccountStatementRecordOpen: false,
      };
    },
    computed: {
      filteredItems() {
        return this.items.filter((item) => {
          const filterKUNNR =
            !this.selectedKUNNR || item.KUNNR === this.selectedKUNNR;
          const filterSTCD1 =
            !this.selectedSTCD1 || item.STCD1 === this.selectedSTCD1;
          const filterTIPO =
            !this.selectedTIPO || item.TIPO === this.selectedTIPO;

          return filterKUNNR && filterSTCD1 && filterTIPO;
        });
      },
      sumExpired() {
        return this.items.reduce((total, item) => {
          return !item.inserted ? total + parseFloat(item.vencido) : total;
        }, 0);
      },
      sumToExpire() {
        return this.items.reduce((total, item) => {
          return !item.inserted ? total + parseFloat(item.por_vencer) : total;
        }, 0);
      },
      sumAmount() {
        return this.items.reduce((total, item) => {
          if (!item.inserted) {
            let subTotal = 0;
            if (item.DETFAC && item.DETFAC.length > 0) {
              subTotal += item.DETFAC.reduce((totalDetFac, detail) => {
                return totalDetFac + (parseFloat(detail.DMBTR) || 0);
              }, 0);
            }
            return total + subTotal + (parseFloat(item.DMBTR) || 0);
          }
          return total;
        }, 0);
      },
      documentsAll() {
        const documentos = this.items.map((item) => ({
          option: item.TIPO,
          value: item.TIPO,
        }));
        return [{ option: 'Todos los Documentos', value: '' }, ...documentos];
      },
      customersAll() {
        const documentos = this.items
          .filter((item) => !item.inserted)
          .map((item) => ({
            option: this.$options.filters.formatCustomer(item.KUNNR),
            value: item.KUNNR,
          }));
        return [{ option: 'Todos los Clientes', value: '' }, ...documentos];
      },
      rfcAll() {
        const documentos = this.items
          .filter((item) => !item.inserted)
          .map((item) => ({ option: item.STCD1, value: item.STCD1 }));
        return [{ option: 'Todos los RFC', value: '' }, ...documentos];
      },
      concepts() {
        const uniqueConcepts = new Set();
        return this.items.flatMap((item) =>
          item.DETFAC && item.DETFAC.length > 0
            ? item.DETFAC.filter(
                (concept) =>
                  concept.AUGRU !== '' &&
                  !uniqueConcepts.has(concept.AUGRU) &&
                  uniqueConcepts.add(concept.AUGRU)
              ).map((concept) => ({
                code: concept.AUGRU,
                description: concept.DESCR,
              }))
            : []
        );
      },
      flattenedItemsDocuments() {
        return this.items.flatMap((item) => [
          { ...item, documentType: item.TIPO },
          ...item.DETFAC.map((detail) => ({
            ...detail,
            documentType: `${detail.TIPO}${
              detail.AUGRU ? ` (${detail.AUGRU})` : ''
            }`,
          })),
        ]);
      },
    },
    watch: {
      dataClient() {
        this.generateExcel();
      },
      items() {
        this.generateExcel();
      },
    },
    mounted() {
      this.customerCode = this.validateCustomerCode();
      this.getDataClient();
      this.getCustomersAccounts();
      this.getBonus();
      this.generatePDF();
    },
    methods: {
      ...mapActions({
        sendToExcel: 'printer/sendToExcel',
        sendToPDF: 'printer/sendToPDF',
      }),
      async getDataClient() {
        try {
          let response = await axios.post('grupo-cliente/data-client', {
            client: this.customerCode,
            VKORG: this.user.VKORG,
            VTWEG: this.user.VTWEG,
            VKBUR: this.user.VKBUR,
            P_OPCGPO: this.opt != 'byGroup' ? 0 : '',
          });

          this.dataClient = response.data.dataDetailClient;
          this.loader = false;
        } catch (error) {
          this.loader = false;
        }
      },
      async getCustomersAccounts() {
        this.loading = true;

        try {
          let response = await axios.get('customers-account-statement', {
            params: {
              customer_code: this.customerCode,
              P_VTWEG: this.user.VTWEG,
              P_VKORG: this.user.VKORG,
              P_OPCGPO: this.opt != 'byGroup' ? 0 : '',
            },
            timeout: 5 * 60 * 1000, // 5 minutes — avoids ECONNABORTED when the request takes long
          });

          this.items = this.reorderItemsData(response.data.data);
        } catch {
          this.messageAlert =
            'Ocurrió un error al mostrar el listado de clientes.';
        } finally {
          this.loading = false;
        }
      },
      async getBonus() {
        try {
          let response = await axios.get(
            'customers-account-statement/get-bonus',
            {
              params: {
                customerCode: this.customerCode,
                channel: this.user.VTWEG,
              },
              timeout: 5 * 60 * 1000, // 5 minutes — avoids ECONNABORTED when the request takes long
            }
          );

          const bonus = response.data.data;
          this.bonus = bonus.find((item) => item.CODIGO === '262');
          this.bonusRebate = bonus.find((item) => item.CODIGO === '2RC');
          this.disableMultipayment = this.bonus.DISPO === '0';
          this.disableMultipaymentRebate = this.bonusRebate.DISPO === '0';
        } catch (error) {
          // TODO: resolve error
        }
      },
      validateInsertOrDelete(invoice) {
        !invoice.isOpen
          ? this.insertNewsObjects(invoice)
          : this.deleteNewsObjects(invoice);
      },
      insertNewsObjects(invoice) {
        invoice.DETFAC.forEach((item, index) => {
          item.inserted = true;
          item.idInvoice = invoice.BELNR;
          this.items.splice(
            this.getPositionItem(invoice.BELNR) + index + 1,
            0,
            item
          );
        });
        this.setPropertyIsOpen(true, invoice.BELNR);
      },
      deleteNewsObjects(invoice) {
        this.items = this.items.filter(
          (item) => item.idInvoice !== invoice.BELNR
        );
        this.setPropertyIsOpen(false, invoice.BELNR);
      },
      setPropertyIsOpen(isOpen, BELNR) {
        const position = this.getPositionItem(BELNR);
        this.$set(this.items[position], 'isOpen', isOpen);
      },
      getPositionItem(BELNR) {
        return this.items.findIndex((item) => item.BELNR === BELNR);
      },
      reorderNotApplied(items) {
        const notApplied = items.filter((item) => item.TIPO !== 'FACTURA');
        const applied = items.filter((item) => item.TIPO === 'FACTURA');
        return [...notApplied, ...applied];
      },
      reorderExpired(items) {
        const expired = items.filter((item) => item.ESTAT === 'VENCIDO');
        const withoutExpire = items.filter((item) => item.ESTAT !== 'VENCIDO');
        return [...expired, ...withoutExpire];
      },
      reorderItemsData(items) {
        items = this.reorderNotApplied(items);
        return this.reorderExpired(items);
      },
      generatePDF() {
        this.sendToPDF({ height: 1200 });
      },
      generateExcel() {
        this.itemCSV = [
          this.createRow({
            C1: 'Datos del Cliente',
          }),

          this.createRow({
            C1: 'Nombre del Cliente',
            C2: 'RFC',
            C3: 'Número del Cliente',
          }),

          this.createRow({
            C1: this.dataClient.NAME1,
            C2: this.dataClient.STCD1,
            C3: this.dataClient.KUNNR,
          }),

          this.createRow(),

          this.createRow({
            C1: 'Cartera y Línea de crédito',
          }),

          this.createRow({
            C1: 'Límite de crédito',
            C2: 'Línea de crédito comprometida',
            C3: 'Línea de crédito disponible',
            C4: 'Plazo en días',
            C5: 'Saldo Vencido',
            C6: 'Saldo Total',
            C7: 'Notas de Crédito por aplicar',
            C8: 'Documentos pendientes por aplicar',
          }),

          this.createRow({
            C1: this.dataClient.KLIMK,
            C2: `$${this.dataClient.SKFOR}`,
            C3: `$${this.dataClient.CREDD}`,
            C4: this.dataClient.VTEXT,
            C5: `$${this.dataClient.SVENC}`,
            C6: `$${this.dataClient.STOTA}`,
            C7: `$${this.dataClient.NCPA}`,
            C8: `$${this.dataClient.PPPA}`,
          }),

          this.createRow(),

          this.createRow({
            C1: `Movimientos al ${this.dateCurrent}`,
          }),

          this.createRow({
            C1: 'N° de Cliente',
            C2: 'RFC',
            C3: 'N° de documento',
            C4: 'Orden de Compra',
            C5: 'Tipo de documento',
            C6: 'Fecha de documento',
            C7: 'Fecha de entrega',
            C8: 'Fecha de vencimiento',
            C9: 'Días vencido',
            C10: 'Importe',
            C11: 'Saldo sin vencer',
            C12: 'Saldo Vencido',
          }),

          ...this.items.map((item) =>
            this.createRow({
              C1: item.KUNNR,
              C2: item.STCD1,
              C3: item.BELNR,
              C4: item.ORDCOM,
              C5: item.TIPO,
              C6: item.BUDAT,
              C7: item.FACUS,
              C8: item.FVENC,
              C9: item.DVENC,
              C10: `$${item.DMBTR}`,
              C11:
                item.por_vencer != null && item.por_vencer !== ''
                  ? `$${item.por_vencer}`
                  : '',
              C12:
                item.vencido != null && item.vencido !== ''
                  ? `$${item.vencido}`
                  : '',
            })
          ),

          this.createRow({
            C10: 'Subtotales',
            C11: `$${this.sumToExpire}`,
            C12: `$${this.sumExpired}`,
          }),

          this.createRow({
            C11: 'Saldo total',
            C12: `$${this.sumAmount}`,
          }),
        ];

        this.sendToExcel({ items: this.itemCSV });
      },
      createRow(columns = {}) {
        const row = {};

        for (let i = 1; i <= 13; i++) {
          row[`C${i}`] = columns[`C${i}`] ?? '';
        }

        return row;
      },
      async buildPdfReport() {
        const doc = new jsPDF({
          unit: 'mm',
          format: [240, 500],
        });
        let posY = await this.addPdfHeader(doc, 'Estado de cuenta');

        const customerData = {
          columns: [
            { header: '', dataKey: 'col1' },
            { header: '', dataKey: 'col2' },
          ],
          rows: [
            {
              col1: `Nombre del cliente: ${this.dataClient.NAME1}`,
              col2: `Número de cliente: ${Number(this.dataClient.KUNNR)}`,
            },
            {
              col1: `Domicilio: ${this.dataClient.STREET} N° ${this.dataClient.HOUSE_NUM1}, ${this.dataClient.CITY2}. CP. ${this.dataClient.POST_CODE1}`,
              col2: `RFC: ${this.dataClient.STCD1}`,
            },
          ],
        };

        const customerPortfolioData = {
          columns: [
            { header: '', dataKey: 'col1' },
            { header: '', dataKey: 'col2' },
          ],
          rows: [
            {
              col1: `Límite de crédito: ${this.formatNumber(
                this.dataClient.KLIMK
              )}`,
              col2: `Saldo vencido: ${this.formatNumber(
                this.dataClient.SVENC
              )}`,
            },
            {
              col1: `Línea de crédito comprometida: ${this.formatNumber(
                this.dataClient.SKFOR
              )}`,
              col2: `Saldo total: ${this.formatNumber(this.dataClient.STOTA)}`,
            },
            {
              col1: `Línea de crédito disponible: ${this.formatNumber(
                this.dataClient.CREDD
              )}`,
              col2: `Notas de crédito por aplicar: ${this.formatNumber(
                this.dataClient.NCPA
              )}`,
            },
            {
              col1: `Plazo en días: ${this.extractLastWords(
                this.dataClient.VTEXT
              )}`,
              col2: `Documentos pendientes por aplicar: ${this.formatNumber(
                this.dataClient.PPPA
              )}`,
            },
            {
              col1: `PPDP últimos 3 meses (#docs): ${this.dataClient.PPDP} (${this.dataClient.DOCDP})`,
              col2: '',
            },
          ],
        };

        const customerBonuses = {
          columns: [
            { header: '', dataKey: 'col1' },
            { header: '', dataKey: 'col2' },
          ],
          rows: [
            {
              col1: `Bono Rebate (sin IVA): ${this.formatNumber(
                this.bonusRebate.MONTO
              )}\nSaldo disponible: ${this.formatNumber(
                this.bonusRebate.DISPO
              )}`,
              col2: `Bono POP (sin IVA): ${this.formatNumber(
                this.bonus.MONTO
              )}\nSaldo disponible: ${this.formatNumber(this.bonus.DISPO)}`,
            },
          ],
        };

        const creditNotesData = {
          columns: [
            { header: 'Concepto', dataKey: 'code' },
            { header: 'Descripción concepto', dataKey: 'description' },
          ],
          rows: this.concepts,
        };

        const documentsData = {
          columns: [
            { header: '# documento', dataKey: 'BELNR' },
            { header: 'Orden compra', dataKey: 'ORDCOM' },
            { header: 'Tipo de documento', dataKey: 'documentType' },
            { header: 'Fecha de documento', dataKey: 'BUDAT' },
            { header: 'Fecha de entrega', dataKey: 'FACUS' },
            { header: 'Fecha de vencimiento', dataKey: 'FVENC' },
            { header: 'Días vencidos', dataKey: 'DVENC' },
            { header: 'Importe', dataKey: 'DMBTR', format: 'currency' },
            {
              header: 'Saldo sin vencer',
              dataKey: 'por_vencer',
              format: 'currency',
            },
            { header: 'Saldo vencido', dataKey: 'vencido', format: 'currency' },
          ],
          rows: this.flattenedItemsDocuments,
        };

        const totalBalance = {
          columns: [{ header: '', dataKey: 'col1' }],
          rows: [
            {
              col1: `Saldo Total: ${this.formatNumber(this.sumAmount)}`,
            },
          ],
        };

        posY = this.createTable(doc, customerData, 'Datos del cliente', posY);
        posY = this.createTable(
          doc,
          customerPortfolioData,
          `Cartera y línea de crédito al ${this.dateCurrent}`,
          posY
        );
        posY = this.createTable(doc, customerBonuses, 'Bonos', posY);
        posY = this.createTable(
          doc,
          documentsData,
          `Movimientos del ${this.dateCurrent}`,
          posY
        );

        const redRowStyles = {
          fillColor: [163, 0, 20],
          textColor: [255, 255, 255],
          halign: 'right',
        };
        posY = this.createTable(doc, totalBalance, '', posY, redRowStyles);
        posY = this.createTable(
          doc,
          creditNotesData,
          'Información de notas de crédito/Cargo',
          posY
        );

        this.addPdfFooter(doc, posY);
        doc.save('report-account-statement.pdf');
      },
    },
  };
</script>

<style scoped>
  .foot-total {
    background: transparent
      linear-gradient(180deg, var(--light-🌕-error-b00020) 0%, #580010 100%) 0%
      0% no-repeat padding-box;
    border: 1px solid var(--gris-de-las-tablas);
    background: transparent linear-gradient(180deg, #b00020 0%, #580010 100%) 0%
      0% no-repeat padding-box;
    border: 1px solid #dde1e6;
    opacity: 1;
    height: 28px !important;
    color: #fff;
  }
  .foot-sub-total {
    background: rgb(245, 245, 245);
    height: 30px !important;
  }
  .btn-multipago {
    color: #fff !important;
    text-transform: inherit !important;
    height: 25px !important;
    font-size: 12px !important;
    min-width: 210px !important;
    border-radius: 10px;
  }
  .buttons__container {
    margin-top: 20px;
    display: flex;
    flex-flow: row wrap;
  }
  .buttons__colum {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    opacity: 1;
    padding: 10px 20px;
  }
  .buttons__colum-1 {
    flex: 2;
  }
  .buttons__colum-2 {
    flex: 1;
  }
  .buttons__colum-3 {
    flex: 1;
  }
  .buttons__colum-4 {
    flex: 2;
  }
  .button-green {
    background: transparent
      linear-gradient(180deg, var(--success-hover-218838) 0, #11441c 100%) 0 0
      no-repeat padding-box;
    background: transparent linear-gradient(180deg, #218838, #11441c) 0 0
      no-repeat padding-box;
    background-color: transparent;
  }
  ::v-deep table tbody td {
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    border: 1px solid var(--gris-de-las-tablas);
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #dde1e6;
    opacity: 1;
    height: auto !important;
    padding: 4px !important;
    width: 8%;
  }
  ::v-deep table thead th {
    font-weight: 500 !important;
    font-family: Roboto !important;
    background: #f3f3f3 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    opacity: 1;
    border-bottom: 2px solid #707070 !important;
    font-size: 14px !important;
    text-align: center !important;
    padding: 5px 8px !important;
    height: auto !important;
  }
  ::v-deep table thead .v-input__slot,
  ::v-deep table thead .v-input__control {
    min-height: auto !important;
    background: transparent linear-gradient(180deg, #a82222 0%, #ff0000 100%) 0%
      0% no-repeat padding-box !important;
    opacity: 1;
  }
  ::v-deep table thead .v-input__slot .v-icon {
    color: #fff !important;
  }
  ::v-deep table .v-input__slot .v-label,
  ::v-deep table .v-input__slot .v-select__selection {
    font-size: 11px !important;
    color: #fff !important;
  }
</style>
